import { render } from "./SortingTableHeader.vue?vue&type=template&id=fff29c46"
import script from "./SortingTableHeader.vue?vue&type=script&lang=js"
export * from "./SortingTableHeader.vue?vue&type=script&lang=js"

import "./SortingTableHeader.vue?vue&type=style&index=0&id=fff29c46&scope=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__